import { fetcher } from '@commenda/utils';

import { UpdateBillingQuoteDefaultSubscriptionTermsParams } from './types';

export const updateBillingQuoteDefaultSubscriptionTerms = ({
  quoteId,
  ...terms
}: UpdateBillingQuoteDefaultSubscriptionTermsParams) =>
  fetcher(`commenda-billing/quotes/${quoteId}/default-subscription-terms`, {
    method: 'PATCH',
    body: terms,
  });
